import dayjs from "dayjs"
import { find, some } from 'lodash'

let openedParentSession = JSON.parse(localStorage.getItem('opened_parent_session')) || null

const sessions = {
  namespaced: true,

  state: {
    sessions: [],
    openedParentSession,
    search: '',
    sessionsSettings: {
      showSearch: true,
      showRoomFilter: false,
      showTopicFilter: false,
      filtersAboveDates: false
    }
  },

  mutations: {
    setSessions (state, sessions) {
      state.sessions = sessions
    },
    setSessionsSettings (state, settings) {
      state.sessionsSettings = settings
    },
    changeOpenedParentSession: (state, session) => {
        if(!session.parent_id) {
          if(state.openedParentSession == session.id) {
            state.openedParentSession = null
            localStorage.setItem('opened_parent_session', JSON.stringify(null))
          } else {
              state.openedParentSession = session.id
              localStorage.setItem('opened_parent_session', JSON.stringify(session.id))
          }
        }
    },
    updateSearch (state, search) {
      state.search = search
    },
  },

  getters: {
    currentSession: state => roomId => {
      const currentTime = dayjs()

      return state.sessions.find(session => {
        const sessionStart = dayjs(session.start)
        const sessionEnd = dayjs(session.end)

        if (roomId && session.room_id !== roomId) {
          return false
        }

        return currentTime.isSameOrAfter(sessionStart) && currentTime.isSameOrBefore(sessionEnd)
      })
    },
    isOpenedParentSession: state => sessionId => {
      return state.openedParentSession == sessionId
    },

    showSession: (state, getters) => (id, subsessions) => {
      const session = find(subsessions || state.sessions, { id })
      if(session) {
        if(state.search) {
          const isSearched = session.name.toLowerCase().indexOf(state.search.toLowerCase()) !== -1 ||
          (session.code && session.code.toLowerCase() == state.search.toLowerCase()) ||
          some(session.speakers, speaker =>
            `${speaker.name} ${speaker.surname}`.toLowerCase().indexOf(state.search.toLowerCase()) !== -1 ||
          speaker.subtitle.toLowerCase().indexOf(state.search.toLowerCase()) !== -1)
          return isSearched
        } else {
          const isNaturallyVisible = session && (!session.parent_id || state.openedParentSession == session.parent_id)
          return isNaturallyVisible
        }
      }
      return false
    },

    sessionHasVisibleSubsessions: (state, getters) => id => {
      if(state.search) {
        const session = find(state.sessions, { id })
        const hasVisibleSubsessions = some(session.sub_sessions, subSession => getters.showSession(subSession.id, session.sub_sessions))
        return hasVisibleSubsessions
      }
      return true
    }
  },

  actions: {
    getSessions ({ commit }) {
      axios.get('/sessions/data/')
        .then(response => {
          commit('setSessions', response.data.sessions)
          commit('setSessionsSettings', response.data.settings)
        })
    }
  }
}

export default sessions
